import gql from 'graphql-tag';

export const PricingGroupDetails = gql`
  fragment PricingGroupDetails on PricingGroup {
    id
    name
    print_partner {
      id
      name
    }
    photo_pricing {
      id
      name
      internal_name
      print_partner {
        id
        name
      }
      pricing_categories(slice: { limit: 999 }) {
        records {
          id
          pricing_category {
            id
            name
          }
        }
      }
    }
    print_packages(slice: { limit: 999 }) {
      total
      records {
        id
        print_package {
          id
          name
          internal_name
          print_partner {
            id
            name
          }
          price {
            value
            currency
          }
          pricing_categories(slice: { limit: 999 }) {
            records {
              id
              pricing_category {
                id
                name
              }
            }
          }
        }
      }
    }
    custom_prints(slice: { limit: 999 }) {
      total
      records {
        id
        custom_print {
          id
          name
          type
          subtype
          print_product_size {
            id
            print_product {
              id
              print_partner {
                id
                name
              }
            }
          }
          price {
            value
            currency
          }
          pricing_categories(slice: { limit: 999 }) {
            records {
              id
              pricing_category {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`;

export default PricingGroupDetails;
